import "./App.css";
import React from "react";
import Navbar from "./components/Navbar/Navbar";

import Footer from "./components/Footer/Footer";

import Home from "./components/Home/Home";

import FAQ from "./components/FAQ/FAQ";
import { Routes, Route } from "react-router-dom";
import LaunchNow from "./components/LaunchNow/LaunchNow";
import Borrow from "./components/Borrow/Borrow";

function App() {
  return (
    <div>
      <Navbar></Navbar>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/launch" element={<LaunchNow />} />
        <Route path="/borrow" element={<Borrow />} />
        {/* Add other routes as needed */}
      </Routes>

      {/* Footer */}
      <Footer></Footer>
    </div>
  );
}

export default App;
